import React from 'react';
import styles from './EmailAuth.module.css';
import { Link } from 'react-router-dom';
import { FiArrowRightCircle } from "react-icons/fi";
import validator from 'validator';
import * as utils from '../../utils/utils';

export default class EmailAuth extends React.Component {

    constructor(props) {
        super(props);

        this.screens = {
            Signup: 1,
            SigningUp: 2,
        };

        this.state = {
            currentScreen: this.screens.Signup,

            email: '',
        };
    };

    componentDidMount() {
    };

    signup = (event) => {
        event.preventDefault();

        const email = this.state.email.trim();

        if ( !validator.isEmail(email) ) {
            alert('Please provide a valid email.');
            return;
        }

        this.setState({
            currentScreen: this.screens.SigningUp,
        }, () => {
            utils.sendRequest('/web/user/signup',{
                email,
            })
            .then(responseData => {
                const {
                    userID,
                    userUniqueID,
                } = responseData;

                utils.setAuthDetails(userID, userUniqueID);
                utils.setUserInfo({
                    email,
                });

                window.location.reload();
            })
            .catch(error => {
                this.setState({
                    currentScreen: this.screens.Signup,
                });
                console.log('signup error', error);
                alert('There was an error. Please try again in a bit.');
            });
        });
    };

    renderSignupScreen = () => {
        return (
            <>
                <div className={styles.subtitle}>
                    Signup and Login with email to unlock all quizzes
                </div>

                <form
                    onSubmit={this.signup}
                    className={styles.signupForm}
                >
                    <input
                        type="email"
                        className={styles.emailInput}
                        value={this.state.email}
                        onChange={event => this.setState({ email: event.target.value })}
                    />

                    <button
                        type="submit"
                        className={styles.button}
                    >
                        Unlock
                    </button>
                </form>

                <div className={styles.infoText}>
                    A SnapQuizAI account will be created, allowing you to access quizzes from anywhere.<br />
                    We do not spam.
                </div>

            </>
        );
    };

    renderSigningUpScreen = () => {
        return (
            <>
                <div className={styles.subtitle}>
                    Unlocking quizzes...
                </div>
            </>
        );
    };

    renderCurrentScreen = () => {
        const {
            currentScreen
        } = this.state;

        if ( currentScreen === this.screens.Signup ) {
            return this.renderSignupScreen();
        }
        else if ( currentScreen === this.screens.SigningUp ) {
            return this.renderSigningUpScreen();
        }
    };

    render() {
        return (
            <div className={styles.rootView}>
                <div className={styles.content}>
                    {this.renderCurrentScreen()}
                </div>
            </div>
        );
    };
};